"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleInteraction = exports.ErrCode = void 0;
var ErrCode;
(function (ErrCode) {
    ErrCode["ErrCodeOK"] = "ErrCodeOK";
    ErrCode["ErrCodeNotFound"] = "ErrCodeNotFound";
    ErrCode["ErrCodeUnkown"] = "ErrCodeUnkown";
    ErrCode["ErrCodeGetFailed"] = "ErrCodeGetFailed";
    ErrCode["ErrCodeUnLogin"] = "ErrCodeUnLogin";
    ErrCode["ErrCodeNonsupport"] = "ErrCodeNonsupport";
    ErrCode["ErrCodeInvalidTime"] = "ErrCodeInvalidTime";
})(ErrCode = exports.ErrCode || (exports.ErrCode = {}));
var ModuleInteraction;
(function (ModuleInteraction) {
    ModuleInteraction["None"] = "None";
    ModuleInteraction["RollOver"] = "RollOver";
    ModuleInteraction["SingleSliding"] = "SingleSliding";
    ModuleInteraction["Zoom"] = "Zoom";
    ModuleInteraction["ZoomSliding"] = "ZoomSliding";
})(ModuleInteraction = exports.ModuleInteraction || (exports.ModuleInteraction = {}));
